import React from 'react';
import { ROW_LEFT, ROW_TOP, ROW_BUDGET, PANEL_HEIGHT } from '../panels/registry';

// The row the panel stack's view lives in.
//
// This replaces the per-panel absolute coordinates that used to be scattered
// across App.css and App.tsx. The row is only the frame: each panel is placed
// inside it at the `x` the stack works out (stackPositions in panels/registry),
// packed from the left, so the panels stay put against the Key-Center column
// and whatever slack is left collects on the right.
//
// No z-index on purpose: a positioned element with z-index:auto creates no
// stacking context, so the panels' own z-indexes (.emo-display is 10, the staff
// wrapper is 1) keep resolving against the root exactly as they did when each
// panel was positioned individually. The panels carry no transform at rest for
// the same reason.

interface PanelRowProps {
  children?: React.ReactNode;
}

const PanelRow: React.FC<PanelRowProps> = ({ children }) => {
  const style: React.CSSProperties = {
    position: 'absolute',
    top: `${ROW_TOP}dvw`,
    left: `${ROW_LEFT}dvw`,
    width: `${ROW_BUDGET}dvw`,
    height: `${PANEL_HEIGHT}dvw`,
  };

  return <div className="panel-row" style={style}>{children}</div>;
};

export default PanelRow;
